import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router";
import { Boxes } from "lucide-react";
import { useGetMyFeatures } from "@tubo/api-models/hooks/tenant-feature-api.hooks";
import { Button } from "@tubo/ui/components/ui/button";

export const Route = createFileRoute("/_app/semantic-platform/data-models")({
  component: DataModelLayout,
});

function DataModelLayout() {
  const { data: features, isLoading } = useGetMyFeatures({ query: {} });
  if (isLoading)
    return (
      <div className="flex h-full items-center justify-center text-muted-foreground">
        加载中…
      </div>
    );
  if (!features?.dataModel) {
    return <FeatureDisabled icon={Boxes} title="数据模型中心" />;
  }
  return <Outlet />;
}

function FeatureDisabled({
  icon: Icon,
  title,
}: {
  icon: typeof Boxes;
  title: string;
}) {
  const navigate = useNavigate();
  return (
    <div className="flex h-full items-center justify-center text-muted-foreground">
      <div className="text-center">
        <Icon className="mx-auto mb-3 h-12 w-12 text-icon-secondary-muted" />
        <p className="text-sm font-medium">{title}</p>
        <p className="mt-1 text-xs text-muted-foreground/70">
          该功能尚未对当前租户开放
        </p>
        {/* 直链进入时浏览器历史可能是空/站外，返回固定落知识本体域首页 */}
        <Button
          variant="outline"
          size="sm"
          className="mt-4"
          onClick={() => navigate({ to: "/semantic-platform" })}
        >
          返回
        </Button>
      </div>
    </div>
  );
}
